import React, {Component} from 'react';
import { Card } from 'material-ui/Card';
import TextField from 'material-ui/TextField';
import CircularProgress from 'material-ui/CircularProgress';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import Dialog from 'material-ui/Dialog';
import Toggle from 'material-ui/Toggle';
import _ from "underscore";
import FileSaver from 'file-saver';
import Slide from 'material-ui-beta/transitions/Slide';
import DialogBeta from 'material-ui-beta/Dialog';

import api from '../../api/api';
import attributeIds from '../../api/attributeIds.js';
import Tracker from '../common/Tracker';
import BulkUpload from './BulkUpload';
import AdminLocationDetails from './AdminLocationDetails';

import addIcon from '../../img/ic-f-a-b-add.svg';

import './AdminLocationManager.css';

const PAGE_SIZE = 10;

const CATEGORY = "location manager";

function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class AdminLocationManager extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            locations: null,
            filteredLocations: null,
            locationToDelete: null,
            locationToUnlink: null,
            numRecords: PAGE_SIZE,
            selectedLocation: null
        }
    }

    componentDidMount() {
        Tracker.trackPageView('/location-manager');
        this.fetchLocations();
    }

    fetchLocations() {
        if (this.props.user.isAdmin) {
            api.getAllLocations((locations) => {
                this.setState({
                    loading: false,
                    locations: locations,
                    filteredLocations: [...locations]
                });
            });
        } else {
            api.locationsForOrgId(this.props.user.orgId, (locations) => {
                // this.dataStore.cacheLocations(locations);
                this.setState({
                    loading: false,
                    locations: locations,
                    filteredLocations: [...locations]
                });
            });
        }
    }

    onSearchChange = (event) => {
        // console.log("onSearchChange");
        var filter = event.target.value;
        var filteredLocations;
        if (!filter) {
            filteredLocations = [...this.state.locations];
        } else {
            filter = filter.toLowerCase()
            filteredLocations = _.filter(this.state.locations, (location) => {
                var locationString = JSON.stringify(location).toLowerCase();
                return locationString.indexOf(filter) !== -1;
            });
        }
        this.setState({filteredLocations: filteredLocations});
    }

    onDeleteClick = (location) => {
        Tracker.trackEvent(CATEGORY, "delete click", "", "");
        this.setState({locationToDelete: location});
    }

    closeDialog = () => {
        this.setState({ locationToDelete: null, locationToUnlink: null });
    }

    onLocationToggled = (location, event, checked) => {
        // console.log("onLocationToggled: %o", checked);
        this.setState((state, props) => {
            location.active = checked;
            api.saveLocation(location);
            return {filteredLocations: state.filteredLocations};
        })
    };

    showNextPage = () => {
        Tracker.trackEvent(CATEGORY, "load more click", "", "");
        this.setState((state) => {
            return {numRecords: state.numRecords + PAGE_SIZE};
        })
    };

    deleteLocation = () => {
        Tracker.trackEvent(CATEGORY, "delete confirm", "", "");
        api.deleteLocation(this.state.locationToDelete);
        this.setState({
            loading: true,
            locationToDelete: null
        });
        this.fetchLocations();
    };

    onClearSelection = () => {
        this.setState({
            selectedLocation: null,
            loading: true
        });
        this.fetchLocations();
    };

    onExportClick = () => {
        api.getAttributes((attributes) => {
            let headers = ["Name", "Street Address", "Street Address 2", "City", "State", "Postal Code", "Phone Number", "Fax Number", "Website URL", "Company Type", "Practice Specialty", "Accept Outside Referrals?", "Hospital Based?", "Claimed"];
            let lines = [headers.join("\t")];
            this.state.locations.forEach((location) => {
                let parts = [];

                let keys = ["name", "address1", "address2", "city", "stateAbbr", "postCode", "phoneNumber", "faxNumber", "url"];
                keys.forEach((key) => {
                    parts.push(location[key]);
                });

                let practiceTypeAttribute = location.attributes[attributeIds.practiceType];
                if (practiceTypeAttribute && practiceTypeAttribute.choice && practiceTypeAttribute.choice.length) {
                    parts.push(attributes[5].options[practiceTypeAttribute.choice[0]].name);
                } else {
                    parts.push("");
                }

                let practiceSpecialtyAttribute = location.attributes[attributeIds.practiceSpecialty];
                if (practiceSpecialtyAttribute && practiceSpecialtyAttribute.choice && practiceSpecialtyAttribute.choice.length) {
                    let specialties = [];
                    location.attributes[attributeIds.practiceSpecialty].choice.forEach((choice) => {
                        specialties.push(attributes[2].options[choice].name);
                    });
                    parts.push(specialties.join("; "));
                } else {
                    parts.push("");
                }

                let outsidePatientsAttribute = location.attributes[attributeIds.acceptsOutsidePatients];
                if (outsidePatientsAttribute && outsidePatientsAttribute.choice && outsidePatientsAttribute.choice.length) {
                    if (outsidePatientsAttribute.choice[0] === "149a4669") {
                        parts.push("No");
                    } else {
                        parts.push("Yes");
                    }
                } else {
                    parts.push("");
                }

                let hospitalBasedAttribute = location.attributes[attributeIds.hospitalBasedAttribute];
                if (hospitalBasedAttribute && hospitalBasedAttribute.choice && hospitalBasedAttribute.choice.length) {
                    if (hospitalBasedAttribute.choice[0] === attributeIds.hospitalBased) {
                        parts.push("Yes");
                    } else {
                        parts.push("No");
                    }
                } else {
                    parts.push("");
                }

                parts.push(!!location.orgId);

                lines.push(parts.join("\t"));
            });
            var blob = new Blob([lines.join("\n")], {type: "text/plain;charset=utf-8"});
            FileSaver.saveAs(blob, "export.tsv");
        });
    }

    onUnclaimClick = (location) => {
        this.setState({ locationToUnlink: location });
    }

    unlinkLocation = () => {
        var location = this.state.locationToUnlink;
        if (location) {
            location.orgId = null;
            api.saveLocation(location);
            this.setState({ locationToUnlink: null });
        }
    }

    onGenerateReportsClick = () => {
        api.generateReports();
    };

    onSelect = (location) => {
        this.setState({
            selectedLocation: location
        })
    };

    render() {
        return (
            <div style={{display: "flex", flexDirection: "column", height: "100%"}}>
                {this.state.loading ?
                    <div style={{marginTop: "150px", display: "flex", width: "100%", alignItems: "center", justifyContent: "center"}}>
                        <CircularProgress size={50} thickness={5} />
                    </div>
                    :
                    <div style={{width: "100%", display: "flex", flexDirection: "column", alignItems: "center", flex: 1, position: "relative"}}>
                        <div style={{width: "720px", display: "flex", alignItems: "flex-end", justifyContent: "flex-end", zIndex: "1200 !important"}}>
                            <FloatingActionButton
                                secondary={true}
                                mini={true}
                                style={{marginTop: "20px", alignSelf: "flex-end", zIndex: "1200 !important"}}
                                onClick={this.onSelect.bind(null, {})}>
                                <img src={addIcon} width="20px" alt="" />
                            </FloatingActionButton>
                        </div>
                        <div style={{width: "100%", display: "flex", flexDirection: "column", alignItems: "center", overflow: "scroll", flex: 1, position: "relative"}}>
                            <div style={{height: "100%", width: "720px"}}>
                                {this.props.user.isAdmin ?
                                    <div style={{display: "flex", alignItems: "flex-end", justifyContent: "flex-end"}}>
                                        <div style={{marginRight: "20px"}}>
                                            <RaisedButton
                                                onClick={this.onExportClick}
                                                primary={true}
                                                labelStyle={{color: "#ffffff"}}
                                                label="Export Locations" />
                                        </div>
                                        <div>
                                            <BulkUpload />
                                        </div>
                                    </div>
                                    :
                                    null
                                }
                                <div>
                                    <TextField
                                        hintText="East Side Infusions"
                                        floatingLabelText="Search"
                                        fullWidth={true}
                                        onChange={this.onSearchChange}/>
                                </div>
                                <div style={{paddingBottom: "30px"}}>
                                    {this.state.filteredLocations.map((location, index) => {
                                        if (index < this.state.numRecords) {
                                            return (
                                                <LocationItem
                                                    record={location}
                                                    onEditClick={this.onSelect.bind(null, location)}
                                                    onDeleteClick={this.onDeleteClick.bind(location)}
                                                    onUnclaimClick={this.onUnclaimClick}
                                                    isAdmin={this.props.user.isAdmin}
                                                    onLocationToggled={this.onLocationToggled}
                                                    key={"location-" + index} />
                                            )
                                        }
                                        return null;
                                    })}
                                    {this.state.numRecords < this.state.filteredLocations.length ?
                                        <div style={{marginTop: "30px", textAlign: "center"}}>
                                            <RaisedButton
                                                label="Load More Locations"
                                                onClick={this.showNextPage}
                                                primary={true}
                                                fullWidth={true}
                                                labelStyle={{color: "white"}} />
                                        </div>
                                        :
                                        null
                                    }
                                </div>
                            </div>
                            <Dialog
                                title="Confirm Delete"
                                actions={[
                                    <FlatButton label="Cancel" onClick={this.closeDialog} />,<FlatButton label="delete" onClick={this.deleteLocation} />
                                ]}
                                modal={false}
                                open={this.state.locationToDelete != null}
                                onRequestClose={this.closeDialog}
                            >
                                Are you sure you want to delete {this.state.locationToDelete ? this.state.locationToDelete.name : ""}?
                            </Dialog>
                            <Dialog
                                title="Confirm Unclaim"
                                actions={[
                                    <FlatButton label="Cancel" onClick={this.closeDialog} />,<FlatButton label="Unclaim" onClick={this.unlinkLocation} />
                                ]}
                                modal={false}
                                open={this.state.locationToUnlink != null}
                                onRequestClose={this.closeDialog}>
                                You are about to unlink the Organization tied to this Location. Are you sure you want to proceed?
                            </Dialog>
                        </div>
                    </div>
                }
                <DialogBeta
                    fullScreen
                    open={this.state.selectedLocation !== null}
                    onClose={this.handleClose}
                    transition={Transition}>
                    {this.state.selectedLocation ?
                        <AdminLocationDetails
                            location={this.state.selectedLocation}
                            onClearSelection={this.onClearSelection}
                            user={this.props.user}/>
                        :
                        <div/>
                    }
                </DialogBeta>
            </div>
        );

    }
}

class LocationItem extends Component {
    render() {
        return (
            <Card style={{marginTop: "32px"}}>
                <div>
                    {!this.props.record.active ?
                        <div className="location-item-pending">
                            Pending Approval
                        </div>
                        :
                        null
                    }
                    <div className="location-item-top-row">
                        <div className="location-item-top-row-info">
                            <div className="location-item-name">
                                {this.props.record.name}
                            </div>
                            <div className="location-item-address">
                                <div>
                                    {this.props.record.address1}
                                </div>
                                <div>
                                    {this.props.record.city}, {this.props.record.stateAbbr} {this.props.record.postCode}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="location-item-hr"></div>
                    <div className="location-item-actions">
                        <div>
                            <FlatButton
                                label="edit"
                                labelStyle={{color: "#53c9e8", fontFamily: "Oswald", fontSize: "16px", fontWeight: 400}}
                                onClick={this.props.onEditClick} />
                            <FlatButton
                                label="remove"
                                labelStyle={{color: "#53c9e8", fontFamily: "Oswald", fontSize: "16px", fontWeight: 400}}
                                onClick={this.props.onDeleteClick.bind(null, this.props.record)} />
                            {this.props.isAdmin && this.props.record.orgId ?
                                <FlatButton
                                    label="Unclaim"
                                    labelStyle={{color: "#53c9e8", fontFamily: "Oswald", fontSize: "16px", fontWeight: 400}}
                                    onClick={this.props.onUnclaimClick.bind(null, this.props.record)} />
                                :
                                null
                            }
                        </div>
                        <div style={{display: "flex", justifyContent: "flex-end", alignItems: "center", flex: 1, paddingRight: "10px"}}>
                            {this.props.isAdmin ?
                                <div style={{display: "flex"}}>
                                    <div className="location-item-active-label">Active Listing</div>
                                    <div>
                                        <Toggle
                                            style={{textAlign: "right"}}
                                            toggled={this.props.record.active}
                                            thumbSwitchedStyle={{backgroundColor: "#53c9e8"}}
                                            trackSwitchedStyle={{backgroundColor: "#53c9e8", opacity: "0.3"}}
                                            onToggle={this.props.onLocationToggled.bind(null, this.props.record)} />
                                    </div>
                                </div>
                                :
                                null
                            }
                        </div>
                    </div>
                </div>
            </Card>
        );
    }
}

export default AdminLocationManager;



// WEBPACK FOOTER //
// ./src/components/admin-location-manager/AdminLocationManager.js